<script>
    import { fade } from 'svelte/transition';
    import { push } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import fetchData from '../api.js';
    import { systemUrl} from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";

    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 

    export let params;

    let isLoading = false;
    let search = '';
    let products = [];
    let productsQty = {};
    let productStore = {};
    let cart = {};
    let selectedItems = {};
    let selectedColors = {};
    let selectedColorsMap = {};
    let filteredVariantsMap = {};
    let productNameEdits = {};
    let savingProductName = {};
    let activeProductId = null;
    let activeProductName = '';
    let activeProductOriginalName = '';
    let SupplierName = [];
    let model_Brand = [];
    let Type = [];
    let model_Season = [];
    let model_Collection = [];
    let model_Year = [];
    let filters = {
        model_Brand: '',
        model_Year: '',
        model_Season: '',
        Type: '',
        SupplierName: '',
        model_Collection: '',
        
    };

    let previewImage = null;

    let selectedProductForImages = null;
    

    $: selectedCartId = params?.cart_id ? params.cart_id : null;

       
    $: productStoresMap = products.map(product => 
        [...new Set(
            (product.variants || []).flatMap(v => 
                Object.keys(v.inventory || {})
            )
        )].sort((a, b) => Number(a) - Number(b))
    );

    $: colors = selectedProductForImages
        ? getProductColors(selectedProductForImages)
        : [];

    function getVariantImage(color) {

        return selectedProductForImages.colorImages?.find(
        i => i.color === color
        )?.image_url;

    }

    function getProductColors(product) {

        return [
            ...new Set(
                (product.variants || [])
                    .map(v => v.color)
                    .filter(Boolean)
            )
        ];
    }

    function toggleColor(productIndex, color, product) {

        if (!selectedColorsMap[productIndex]) {
            selectedColorsMap[productIndex] = [];
        }

        const selected = selectedColorsMap[productIndex];

        if (selected.includes(color)) {
            selectedColorsMap[productIndex] = selected.filter(c => c !== color);
        } else {
            selectedColorsMap[productIndex] = [...selected, color];
        }

        updateFilteredVariants(productIndex, product);
    }




    function updateFilteredVariants(productIndex, product) {

        const selected = selectedColorsMap[productIndex];

        if (!selected || selected.length === 0) {
            filteredVariantsMap[productIndex] = product.variants;
        } else {
            filteredVariantsMap[productIndex] =
                product.variants.filter(v => selected.includes(v.color));
        }

        filteredVariantsMap = { ...filteredVariantsMap };
    }


    function toggleSelection(sku, store) {
        selectedItems[sku] ??= {};
        selectedItems[sku][store] ??= { checked: false, qty: 1 };
        selectedItems[sku][store].checked = !selectedItems[sku][store].checked;
        selectedItems = { ...selectedItems };
    }

    function updateQty(sku, store, value,product) {
        selectedItems[sku] ??= {};
        selectedItems[sku][store] ??= { checked: true, qty: 1 };
        selectedItems[sku][store].qty = value;
        selectedItems = { ...selectedItems };
    }

    async function addSelectedToCart(variants, index,parent_sku) {
        for (const variant of variants) {
            const sku = variant.sku;
            for (const store in selectedItems[sku] || {}) {
                const item = selectedItems[sku][store];
                if (!item.checked) continue;
                console.log(variant)
                await addToCart(sku, store, item.qty,variant.name,variant.special_price,variant.product_id,variant.parent_id,parent_sku,variant.regular_price); // your existing function
            }        
        }

        openVariants = { ...openVariants, [index]: false };

    }

    


    let openVariants = {};

    function toggleVariants(index, product = null) {
        const isOpening = !openVariants[index];
        openVariants = { ...openVariants, [index]: isOpening };

        if (isOpening && product?.product_id) {
            activeProductId = product.product_id;
            activeProductName = product.name || '';
            activeProductOriginalName = product.name || '';
            productNameEdits = {
                ...productNameEdits,
                [product.product_id]: product.name
            };
        }
    }

    function handleProductNameInput(productId, value) {
        activeProductId = productId;
        activeProductName = value;
        productNameEdits = {
            ...productNameEdits,
            [productId]: value
        };
    }

    function hasProductNameChanged(product) {
        return activeProductId === product.product_id && activeProductName.trim() !== activeProductOriginalName.trim();
    }

    async function saveProductName(product) {
        const newName = (activeProductName ?? '').trim();

        if (!newName || newName === product.name) {
            return;
        }

        savingProductName = {
            ...savingProductName,
            [product.product_id]: true
        };

        try {
            const postData = {
                action: 'agents_products_update_name',
                token: $UserStore.data,
                product_id: product.product_id,
                name: newName,
                new_name: newName
            };

            const response = await fetchData(postData);

            if (response?.success === false) {
                alert(response?.error || response?.message || 'Failed to update product name');
                return;
            }

            products = products.map((item) =>
                item.product_id === product.product_id
                    ? { ...item, name: newName }
                    : item
            );

            activeProductOriginalName = newName;

            productNameEdits = {
                ...productNameEdits,
                [product.product_id]: newName
            };
        } catch (error) {
            console.error(error);
            alert('Failed to update product name');
        } finally {
            savingProductName = {
                ...savingProductName,
                [product.product_id]: false
            };
        }
    }

    function setQty(sku, qty) {
        productsQty[sku] = qty;

    }
    function setProductStore(sku, store) {
        productStore[sku] = store;
    }



    onMount(async () => {
        if (!$UserStore || !$UserStore.data) {
            push('/login');
            return;
        }


        searchProducts(true);
        getFiltersData();


        window.addEventListener('keydown', closeVariantsOnEsc);
        return () => {
            window.removeEventListener('keydown', closeVariantsOnEsc);
        };

    });

    function closeVariantsOnEsc(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            // Close all open variants (or just the current one)
            openVariants = {};  // simplest: close all
            // Alternative: close only the current one
            // openVariants[index] = false;
        }
    }


    async function getFiltersData() {
        isLoading = true;

        try {
            let postData = {
                action : 'agents_get_filters_data',
                token : $UserStore.data
            }

            const res = await fetchData(postData);

            model_Brand = res?.data?.model_Brand || [];
            model_Season = res?.data?.model_Season || [];
            Type = res?.data?.Type || [];
            SupplierName = res?.data?.SupplierName || [];
            model_Year = res?.data?.model_Year || [];

        } catch (e) {
            console.error(e);
        }

        isLoading = false;
    }

    async function searchProducts(all=false) {
        if (!search && !all) {
            products = [];
            return;
        }

        isLoading = true;

        let postData = {
            q: search,
            filters: filters,
            action : 'agents_products_search',
            token : $UserStore.data
        }

        try {
            const res = await fetchData(postData, {
                method: 'POST',
                body: { q: search }
            });

            // initialize qty per variant
            products = (res?.data || []).map(p => {
                if (p.variants) {
                    p.variants = p.variants.map(v => ({
                        ...v,
                        qty: 0,
                        inventory: JSON.parse(v.inventory) || {}
                    }));
                    productsQty = { ...Object.fromEntries(p.variants.map(v => [v.sku, v.qty])) ,...productsQty }}
                return p;
            });
        } catch (e) {
            console.error(e);
            products = [];
        }

        isLoading = false;
    }

    async function addToCart(sku, store, qty, name, price,product_id,parent_id,parent_sku,price_before_discount) {

        if (qty <= 0) return;

        isLoading = true;

        try {

            let postData = {
                sku,
                quantity: qty,
                store: store,
                name: name,
                price: price,
                price_before_discount: price_before_discount,
                product_id: product_id,
                parent_id: parent_id,
                parent_sku : parent_sku,
                action : 'agents_cart_add',
                token : $UserStore.data,
                cart_id : selectedCartId
            }

            const response = await fetchData(postData);

            if (response?.data?.id) {
                selectedCartId = response?.data?.id;
                cart = response.data;

            }

            if (params?.cart_id != selectedCartId) {
                push(`/agents/products/${selectedCartId}`);
            }

        } catch (e) {
            console.error(e);
        }

        isLoading = false;
    }


    async function deleteVariant(product_id) {
        if (!confirm($_('agents.products.delete_variant_confirm'))) {
            return;
        }

        isLoading = true;

        try {
            let postData = {
                products: product_id,
                action : 'agents_del_products',
                token : $UserStore.data
            }

            let res = await fetchData(postData);
            if (res?.success) {
                alert($_('agents.products.variant_deleted'));
            } else {
                alert($_('agents.products.variant_delete_failed'));
            }
            

        } catch (e) {
            console.error(e);
        }

        isLoading = false;
    }


</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading} />
    <Header />

    <div class="page">
        <TopInfo />

        <div class="shipment">


            <h1 class="text-start">{$_('agents.products.name')}</h1>

            <!-- Search -->
            <div class="search-box">
                <input
                    type="text"
                    placeholder="{$_('agents.products.search')}"
                    bind:value={search}
                />
            </div>
            <div class="grid grid-cols-2 md:grid-cols-6 gap-2 mt-3 mb-[15px]">

                <!-- BRAND
                <select bind:value={filters.model_Brand}>
                    <option value="">{$_('agents.products.brand')}</option>
                    {#each model_Brand as brand}
                        <option value={brand}>{brand}</option>
                    {/each}
                </select> -->

                <!-- SEASON -->
                <select bind:value={filters.model_Season}>
                    <option value="">{$_('agents.products.season')}</option>
                    {#each model_Season as s}
                        <option value={s}>{s}</option>
                    {/each}
                </select>

                <!-- TYPE -->
                <select bind:value={filters.Type}>
                    <option value="">{$_('agents.products.type')}</option>
                    {#each Type as type}
                        <option value={type}>{type}</option>
                    {/each}
                </select>

                <!-- SUPPLIER -->
                <select bind:value={filters.SupplierName}>
                    <option value="">{$_('agents.products.supplier')}</option>
                    {#each SupplierName as supplier}
                        <option value={supplier}>{supplier}</option>
                    {/each}
                </select>


                <select bind:value={filters.model_Year}>
                    <option value="">{$_('agents.products.year')}</option>
                    {#each model_Year as year}
                        <option value={year}>{year}</option>
                    {/each}
                </select>

                <button
                    class="bg-gray-200 px-3 py-1 rounded"
                    on:click={() => {                    
                        searchProducts(true);
                    }}
                >
                    {$_('agents.products.search_button')}
                </button>

                <button
                    class="bg-gray-200 px-3 py-1 rounded"
                    on:click={() => {
                        filters = {
                            search: '',
                            model_Brand: '',
                            model_Collection: '',
                            model_Year: '',
                            model_Season: '',
                            Type: '',
                            SupplierName: ''
                        };
                        search = '';
                        searchProducts(true);
                    }}
                >
                    {$_('agents.products.clear_filters')}
                </button>
                

            </div>

            



            <!-- Products -->
            <div class="products grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-2">
                {#if products.length === 0 && search}
                    <p>{$_('agents.products.no_results')}</p>
                {/if}

                {#each products as product,index}
                    <div class="product border flex flex-col gap-1">
                        <div class="flex flex-col justify-between items-center cursor-pointer relative">
                            {#if selectedCartId}
                                {#each Object.keys(cart?.items || {}) as itemKey}
                                    {#if cart?.items[itemKey].product_id === product.product_id || cart?.items[itemKey].parent_id === product.product_id}
                                        <div class="absolute top-0 right-0 bg-green-600 text-white text-xs px-1 rounded-bl">
                                            {$_('agents.products.in_cart')}
                                        </div>
                                    {/if}               
                                {/each}
                            {/if}
                            <div class="flex flex-col gap-2 items-center justify-center" on:click={() => toggleVariants(index, product)}>
                                <div class="product-name text-[11px]">
                                    {product.name} - {product.sku}
                                    <!--
                                    {#if product.variants && product.variants.length > 0}
                                        ({product.variants.length} {$_('agents.products.variants')})
                                    {/if}
                                    -->
                                </div>
                            </div>
                            <div class="product-sku text-black font-bold flex items-center gap-2 bg-black text-white rounded px-3 py-1 cursor-pointer mb-[10px]"
                                    on:click={() => toggleVariants(index, product)}>
                                {openVariants[index] 
                                    ? $_('agents.products.open_variants') 
                                    : $_('agents.products.open_variants')}
                                
                                <i class="fa-solid"
                                class:fa-angle-down={!openVariants[index]}
                                class:fa-angle-up={openVariants[index]}>
                                </i>
                            </div>
                        </div>
                        <!-- Variants -->

                        {#if openVariants[index] && product.variants?.length}


                            <div class="variants fixed left-0 w-full h-full px-2 pb-2 top-0 bg-white border z-50 overflow-auto overflow-y-auto">
                                <div class="grid grid-cols-[auto,1fr,auto] items-center gap-2 sticky top-0 bg-white my-2 py-2">
                                    <div class="product-sku text-black font-bold flex items-center gap-2 bg-black text-white rounded px-3 py-1 cursor-pointer"
                                    on:click={() => toggleVariants(index, product)}>
                                        {$_('agents.products.close')}             
                                    </div>

                                    <div class="flex justify-center items-center gap-2 text-center px-2 min-w-0">
                                        <input
                                            class="w-full max-w-[420px] min-w-0 border border-gray-300 rounded px-3 py-2 text-sm md:text-base text-center"
                                            type="text"
                                            bind:value={activeProductName}
                                            on:input={(event) => handleProductNameInput(product.product_id, event.currentTarget.value)}
                                        />

                                        <button
                                            type="button"
                                            class="bg-black text-white rounded px-3 py-2 text-sm whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
                                            disabled={activeProductId !== product.product_id || activeProductName.trim() === activeProductOriginalName.trim() || savingProductName[product.product_id]}
                                            on:click={() => saveProductName(product)}
                                        >
                                            {savingProductName[product.product_id] ? 'Saving...' : 'Save'}
                                        </button>
                                    </div>

                                    <div class="flex gap-1">
                                        {#each [...new Set(product.variants.map(v => v.color))] as color}

                                            <button
                                                class="px-3 py-1 border rounded text-sm
                                                {selectedColorsMap[index]?.includes(color)
                                                    ? 'bg-black text-white'
                                                    : 'bg-gray-100'}"

                                                on:click={() => toggleColor(index, color, product)}
                                            >
                                                {color}
                                            </button>

                                        {/each}

                                    </div>
                 
                                </div>

                                <table class="w-full border mt-3 text-sm">
                                    <thead>
                                        <tr class="bg-gray-100">
                                            <th class="border p-2">SKU</th>
                                            {#each productStoresMap[index] as store}
                                                <th class="border p-2 text-center">{store}</th>
                                            {/each}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {#each filteredVariantsMap[index] || product.variants as variant}
                                            <tr>
                                                <td class="border p-2 flex gap-1">
                                                    <div class="font-small text-[12px]">{variant.color} - {variant.size}</div>
                                                    <div class="text-gray-500 text-[12px]">{variant.sku}</div>
                                                    <div class="bg-black text-white text-[12px] rounded px-2 py-1 cursor-pointer" on:click={()=> deleteVariant(variant.product_id)}>{$_('agents.products.delete')}</div>
                                                </td>

                                                {#each productStoresMap[index] as store}
                                                    <td class="border p-1 text-center">
                                                        {#if (variant.inventory?.[store] ?? 0) > 0}
                                                            <div class="flex items-center gap-1">
                                                                <input
                                                                    class="w-[15px] h-[15px]"
                                                                    type="checkbox"
                                                                    checked={selectedItems?.[variant.sku]?.[store]?.checked || false}
                                                                    on:change={() => toggleSelection(variant.sku, store)}
                                                                />
                                                                <span class="text-green-700 text-xs">{variant.inventory[store]}</span>
                                                                <input
                                                                    type="number"
                                                                    min="1"
                                                                    max={variant.inventory[store]}
                                                                    class="w-14 border rounded px-1 text-center"
                                                                    value={selectedItems?.[variant.sku]?.[store]?.qty || 0}
                                                                    on:input={(e) => updateQty(variant.sku, store, +e.target.value,product)}
                                                                />
                                                            </div>
                                                        {:else}
                                                            <span class="text-red-400">0</span>
                                                        {/if}
                                                    </td>
                                                {/each}
                                            </tr>
                                        {/each}
                                    </tbody>
                                </table>
                            </div>
                        {/if}





                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>

<style>
    .search-box {
        margin: 15px 0;
    }





    .product-name {
        font-weight: bold;
        margin-bottom: 10px;
    }

    .variants {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .variant-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px;
        background: #fafafa;
    }

    .variant-info {
        display: flex;
        flex-direction: column;
    }

    .variant-name {
        font-size: 14px;
    }

    .variant-sku,
    .variant-price {
        font-size: 12px;
        color: #666;
    }

    .variant-actions {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    .variants input[type="number"] {
        width: 50px;
        padding: 2px;
    }


    .border {
        border: 1px solid #efefef;
    }
</style>
